$ {
    const propertyOrdering = input.propertyOrdering;
    const imageSize = input.imageSize;
    const isSmall = input.isSmall;
    const eekIcon = input.eekIcon;
}

<str-ordered-properties
    properties=propertyOrdering
    card=input
    sectionName="info"
    isSmall=isSmall
/>
<str-ordered-properties
    properties=propertyOrdering
    card=input
    sectionName="primary"
    isSmall=isSmall
/>
<if(eekIcon)>
    <div class="str-item-card__bottom">
        <str-eek ...eekIcon />
    </div>
</if>
